
export interface RuleDisplayTree
{
  Kind: RuleDisplayKind;
  Left?: RuleDisplayTree;
  Right?: RuleDisplayTree;
  Group?: RuleDisplayTree[];
  Value?: number|string;
  Values?: (number|string)[];
}

export type RuleDisplayKind =
  | 'PickValue'
  | 'PickConstant'
  | 'PickConstants'
  // | 'PickDocType'
  // | 'PickInfoType'
  | 'GroupAnd'
  | 'GroupOr'
  | 'Equals'
  | 'Contains'
  | 'Matches'
  | 'EqualsAny'
  | 'MatchesAny'
  ;
  
export type PickValueKind =
  | 'FileName'
  | 'FilePath'
  | 'FileExtension'
  | 'Computer'
  | 'DocumentType'
  | 'InfoTypes'
  // | 'Classification'
  ;
  
export const pickerRules = new Set<RuleDisplayKind>([
  'PickValue',
  'PickConstant',
  'PickConstants',
  // 'PickDocType',
  // 'PickInfoType',
])
  
export const groupRules = new Set<RuleDisplayKind>([
  'GroupAnd',
  'GroupOr',
])

export const operatorRules = new Set<RuleDisplayKind>([
  'Equals',
  'Contains',
  'Matches',
  'EqualsAny',
  'MatchesAny',
])







